import { put, takeLatest } from "redux-saga/effects";
import {
  ADD_SHORTLIST_STONE,
  addShortlistStone,
  SET_CC_MODE_CONSUMER_SESSION,
  SET_CC_MODE_PARAMETER_PERMISSIONS,
  SET_CC_MODE_PLAN_FEATURES,
  SET_CC_MODE_SETTING,
  setCcmodeConsumerSession,
  setCcModeParameterPermissions,
  setCcmodePlanFeatures,
  UPDATE_SHORTLIST_STONE_COUNT,
  updateShortlistStoneCount,
} from "./common.actions";

function* updateShortlistStoneCountSaga(action) {
  yield put(updateShortlistStoneCount({ action }));
}

function* addShortlistStoneSaga(action) {
  yield put(addShortlistStone({ action }));
}

function* setCcModeSettingSaga(action) {
  yield put(setCcModeSettingSaga(action));
}

function* setCcModeParameterPermissionsSaga(action) {
  yield put(setCcModeParameterPermissions(action));
}

function* setCcmodeConsumerSessionSaga(action) {
  yield put(setCcmodeConsumerSession(action));
}

function* setCcmodePlanFeaturesSaga(action) {
  yield put(setCcmodePlanFeatures(action));
}

export default function* CommonSaga() {
  yield takeLatest(UPDATE_SHORTLIST_STONE_COUNT, updateShortlistStoneCountSaga);
  yield takeLatest(ADD_SHORTLIST_STONE, addShortlistStoneSaga);
  yield takeLatest(SET_CC_MODE_SETTING, setCcModeSettingSaga);
  yield takeLatest(SET_CC_MODE_PARAMETER_PERMISSIONS, setCcModeParameterPermissionsSaga);
  yield takeLatest(SET_CC_MODE_CONSUMER_SESSION, setCcmodeConsumerSessionSaga);
  yield takeLatest(SET_CC_MODE_PLAN_FEATURES, setCcmodePlanFeaturesSaga);
}
